import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import baseUrl from "../../../baseUrl";
import EmptyData from "../EmptyData/EmptyData";
import Spinner from "../../Spinner/Spinner";
import { toast } from "react-toastify";

const ListBatch = () => {
  const adminToken = JSON.parse(localStorage.getItem("EXAMNP:admin-token"));

  const [batches, setBatches] = useState([]);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  // for loading batches list
  useEffect(() => {
    setLoading(true);
    axios
      .get(`${baseUrl}/admin/get-all-batches`, {
        headers: { Authorization: `Bearer ${adminToken}` },
      })
      .then((res) => {
        if (res.data.success === true) {
          setBatches(res.data.batches);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [adminToken]);

  // handle function for deleting batches
  const handleDeleteBatch = (_id) => {
    axios
      .post(
        `${baseUrl}/admin/delete-batch/${_id}`,
        {
          _id,
        },
        {
          headers: { Authorization: `Bearer ${adminToken}` },
        }
      )
      .then((res) => {
        setBatches(batches.filter((item) => item._id !== _id));
        navigate("/admin/students");
        toast.success(res.data.message);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <>
      {loading && <Spinner />}
      {batches.length <= 0 ? (
        <EmptyData message="Sorry! batches data not found." />
      ) : (
        <table className="table-auto w-full">
          <thead className="text-xs font-semibold uppercase text-gray-400 bg-gray-50">
            <tr>
              <th className="p-2">
                <div className="font-semibold text-left">S.N.</div>
              </th>

              <th className="p-2">
                <div className="font-semibold text-left">Batch Name</div>
              </th>
              <th className="p-2">
                <div className="font-semibold text-left">Batch ID</div>
              </th>
              <th className="p-2">
                <div className="font-semibold text-left">Created At</div>
              </th>
              <th className="p-2">
                <div className="font-semibold text-left">Action</div>
              </th>
            </tr>
          </thead>

          <tbody className="text-sm divide-y divide-gray-100">
            {batches.map((batch, index) => (
              <tr key={index}>
                <td className="p-2">
                  <div className="mb-4 md:mr-2 md:mb-0">
                    <label className="block mb-2 text-sm font-medium text-blue-600">
                      {index + 1}
                    </label>
                  </div>
                </td>

                <td className="p-2">
                  <div className="mb-4 md:mr-2 md:mb-0">
                    <label className="block mb-2 text-sm font-medium text-blue-900">
                      <Link to={`/admin/batch-details/${batch._id}`}>
                        {batch.batchName}
                      </Link>
                    </label>
                  </div>
                </td>
                <td className="p-2">
                  <div className="mb-4 md:mr-2 md:mb-0">
                    <label className="block mb-2 text-sm font-medium text-blue-600">
                      {batch._id}
                    </label>
                  </div>
                </td>
                <td className="p-2">
                  <div className="mb-4 md:mr-2 md:mb-0">
                    <label className="block mb-2 text-sm font-medium text-blue-600">
                      {moment(batch.createdAt).fromNow()}
                    </label>
                  </div>
                </td>

                <td className="p-2">
                  <div className="flex justify-center">
                    <Link to={`/admin/update-batch/${batch._id}`}>
                      <i className="fa-solid fa-pen-to-square w-8 h-8 pt-2 hover:text-green-600 rounded-full hover:bg-green-100 p-1"></i>
                    </Link>
                    <button
                      onClick={() => {
                        handleDeleteBatch(batch._id);
                      }}
                    >
                      <svg
                        className="w-8 h-8 hover:text-red-600 rounded-full hover:bg-red-100 p-1"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                        ></path>
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <hr />
    </>
  );
};

export default ListBatch;
